export default __webpack_public_path__ + "static/realWorldImg3-d0fec7d87bb03ac13932a72ff74ea484.webp";